const cableStates = ['project', 'active', 'fault', 'decommissioned', 'unknown']
export default cableStates
